module.exports = __webpack_public_path__ + "img/lock_with_pen.603a75f5.png";